import { Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard";

export default function DashboardRouter({ targetParentProfile }) {
  return (
    <Routes>
      <Route
        path="/"
        element={<Dashboard targetParentProfile={targetParentProfile} />}
      />
    </Routes>
  );
}
